import { BaseService } from '../types/index.js';
export class Verification extends BaseService {
    checkGoogleRecaptcha(params) {
        return this._request.send({
            method: 'POST',
            url: '/api/app/account/isGoogleRecaptchaOpen',
            params,
        });
    }
    getVerificationCode(requestParams) {
        return this._request.send(Object.assign({ method: 'POST', url: '/api/app/account/sendVerificationRequest' }, requestParams));
    }
    verifyVerificationCode(params) {
        return this._request.send({
            method: 'POST',
            url: '/api/app/account/verifyCode',
            params,
        });
    }
    sendAppleUserExtraInfo(params) {
        return this._request.send({
            method: 'POST',
            url: '/api/app/userExtraInfo/appleUserExtraInfo',
            params,
        });
    }
    getAppleUserExtraInfo(params) {
        return this._request.send({
            method: 'GET',
            url: `/api/app/userExtraInfo/${params.userId}`,
        });
    }
    verifyGoogleToken(params) {
        return this._request.send({
            method: 'POST',
            url: '/api/app/account/verifyGoogleToken',
            params,
        });
    }
    verifyAppleToken(params) {
        return this._request.send({
            method: 'POST',
            url: '/api/app/account/verifyAppleToken',
            params: Object.assign(Object.assign({}, params), { accessToken: params.identityToken }),
        });
    }
    verifyZKLogin(params) {
        return this._request.send({
            method: 'POST',
            url: '/api/app/account/verifiedzk',
            params,
        });
    }
    verifyTelegramToken(params) {
        return this._request.send({
            method: 'POST',
            url: '/api/app/account/verifyTelegramToken',
            params,
        });
    }
    verifyTwitterToken(params, headers) {
        return this._request.send({
            method: 'POST',
            url: '/api/app/account/verifyTwitterToken',
            params,
            headers,
        });
    }
    verifyFacebookToken(params) {
        return this._request.send({
            method: 'POST',
            url: '/api/app/account/verifyFacebookToken',
            params,
        });
    }
    getRecommendationVerifier(params) {
        return this._request.send({
            method: 'POST',
            url: '/api/app/account/getVerifierServer',
            params,
        });
    }
    getTelegramAuthToken(params) {
        return this._request.send({
            method: 'GET',
            url: '/api/app/telegramAuth/token',
            params,
        });
    }
}
